import { Button, Stack } from '@mui/material';
import { PlusIcon } from '@phosphor-icons/react';
import * as uuid from 'uuid';

import { api } from 'common';

import { FilterListBlockFilterOperationCard } from './FilterOperationCard.tsx';
import { useReactFlowViewContext } from '../../../context/context.tsx';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField.ts';

const FilterOperator = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterOperator;
const FilterMatchRule = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterMatchRule;
const CaseSensitivity = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.CaseSensitivity;
type FilterOperation = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterOperation;
type FilterMatchRule = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterMatchRule;

function getDefaultFilterOperationField(): FilterOperation {
  return {
    id: uuid.v4(),
    fieldToFilter: '',
    value: '',
    operator: FilterOperator.Equals,
    caseSensitive: CaseSensitivity.IgnoreCase,
  };
}

export function FilterOperationFields(props: {
  setFilterMatchRule: (filterMatchRule: FilterMatchRule) => void;
}) {
  const { setFilterMatchRule } = props;
  // Provide a default empty array if conditions is null or undefined from previously configured blocks
  const { value: filterOperations = [], setValue } = useSelectedNodeField<FilterOperation[]>(
    'config.baseFilters.filterConfig.filterOperations'
  );
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack gap={2}>
      {filterOperations.map((filterOperation, index) => {
        return (
          <FilterListBlockFilterOperationCard
            key={filterOperation.id}
            fieldNamePrefix={`config.baseFilters.filterConfig.filterOperations.${index}`}
            onDelete={() => {
              setValue(filterOperations.filter((value) => value.id !== filterOperation.id));
            }}
            filterOperation={filterOperation}
          />
        );
      })}
      <Button
        variant="outlined"
        onClick={() => {
          if (filterOperations.length === 0) {
            setFilterMatchRule(FilterMatchRule.All);
          }
          setValue([...filterOperations, getDefaultFilterOperationField()]);
        }}
        sx={{
          alignSelf: 'flex-start',
          gap: 1,
        }}
        disabled={!isEditable}
      >
        <PlusIcon size={16} />
        Add condition
      </Button>
    </Stack>
  );
}
